export const showPage = function() {
    // console.log('showPage');
    document.querySelector("#preloader").remove();
    document.querySelector("#page-container").hidden = false;
}